import { Box, Typography } from '@mui/material';
import buttonStyles from '../constants/buttonSettings';
import Button from './Button';

const { CONTAINED } = buttonStyles;

const ErrorFallback = () => {
  const clickHandler = () => window.location.reload();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: 'background.paper',
        p: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" sx={{ mb: 2 }}>
        Oops!
      </Typography>
      <Typography variant="h1" sx={{ mb: 4 }}>
        Something went wrong on this page. You can contact support anytime using
        <br />
        <a href="mailto:support@fynex.ai">
          <b>support@fynex.ai</b>
        </a>
      </Typography>
      <Button
        size="large"
        variant={CONTAINED}
        onClick={clickHandler}
        fullWidth={false}
      >
        Reload page
      </Button>
    </Box>
  );
};

export default ErrorFallback;
